import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  GetBusinessPartnerRequestByIdResponse,
  ProblemDetails
} from '../../models';

import { useCustomWelcomeClient } from '../../custom-client.tsx';
import type { ErrorType } from '../../custom-client.tsx';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns the business partner request associated with the given onboarding request<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding-backoffice
 */
export const useGetBusinessPartnerRequestByIdHook = () => {
        const getBusinessPartnerRequestById = useCustomWelcomeClient<GetBusinessPartnerRequestByIdResponse>();

        return useCallback((
    onboardingRequestId: string,
 signal?: AbortSignal
) => {


        return getBusinessPartnerRequestById(
          {url: `/business-partner-requests/${onboardingRequestId}`, method: 'GET', signal
    },
          );
        }, [getBusinessPartnerRequestById])
      }




export const getGetBusinessPartnerRequestByIdQueryKey = (onboardingRequestId: string,) => {
    return [
    `/business-partner-requests/${onboardingRequestId}`
    ] as const;
    }


export const useGetBusinessPartnerRequestByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>, TError = ErrorType<ProblemDetails>>(onboardingRequestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessPartnerRequestByIdQueryKey(onboardingRequestId);

  const getBusinessPartnerRequestById =  useGetBusinessPartnerRequestByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>> = ({ signal }) => getBusinessPartnerRequestById(onboardingRequestId, signal);





   return  { queryKey, queryFn, enabled: onboardingRequestId !== null && onboardingRequestId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessPartnerRequestByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>>
export type GetBusinessPartnerRequestByIdQueryError = ErrorType<ProblemDetails>


export function useGetBusinessPartnerRequestById<TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 onboardingRequestId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessPartnerRequestById<TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 onboardingRequestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessPartnerRequestById<TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 onboardingRequestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBusinessPartnerRequestById<TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 onboardingRequestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessPartnerRequestByIdHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBusinessPartnerRequestByIdQueryOptions(onboardingRequestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






